import DevTools from '@/components/DevTools'
import GlobalComponents from '@/components/GlobalComponents'
import GlobalServices from '@/components/GlobalServices'
import Layout from '@/components/Layout'
import ThemeService from '@/components/ThemeService'
import { checkBrowserEnv } from '@/utils/env'
import {
	LIKE_LOTTIE_DATA_QUERY_OPTIONS,
	MANIFEST_QUERY_OPTIONS,
	VIDEO_UPLOAD_LIMIT_QUERY_OPTIONS,
} from '@/utils/fetchers/manifest'
import { currentUserQueryOptions } from '@/utils/fetchers/user'
import queryClient from '@/utils/queryClient'
import { configTracker } from '@/utils/tracker'
import { ModalsProvider } from '@mantine/modals'
import { Outlet, createRootRouteWithContext, redirect } from '@tanstack/react-router'

export const Route = createRootRouteWithContext()({
	component: Root,
	loader: async ({ location, route }) => {
		const isUnsupportedRoute = location.pathname === '/unsupported'
		const isLoginRoute = location.pathname === '/login'

		const isSupported = checkBrowserEnv()

		if (!isSupported) {
			if (!isUnsupportedRoute) {
				throw redirect({
					to: '/unsupported',
				})
			}
			return
		}

		// 被支持的环境
		// 如果处于是未被支持页面，则跳转到首页
		if (isUnsupportedRoute) {
			throw redirect({
				to: '/',
			})
		}

		const basicQueries: Promise<unknown>[] = [queryClient.ensureQueryData(MANIFEST_QUERY_OPTIONS)]

		const isAuthedRoute = !isLoginRoute && !isUnsupportedRoute
		if (isAuthedRoute) {
			basicQueries.push(
				queryClient.ensureQueryData(currentUserQueryOptions).then((user) => {
					configTracker({
						distinctId: user.id,
					})
				}),
				queryClient.ensureQueryData(VIDEO_UPLOAD_LIMIT_QUERY_OPTIONS)
			)
		}

		queryClient.ensureQueryData(LIKE_LOTTIE_DATA_QUERY_OPTIONS)
		await Promise.all(basicQueries)
	},
})

function Root() {
	const isLoginRoute = location.pathname === '/login'
	const isUnsupportedRoute = location.pathname === '/unsupported'

	return (
		<>
			{isLoginRoute || isUnsupportedRoute ? (
				<Outlet />
			) : (
				<Layout>
					<ModalsProvider>
						<Outlet />
					</ModalsProvider>
				</Layout>
			)}
			<DevTools />
			<GlobalComponents />
			<GlobalServices />
			<ThemeService />
		</>
	)
}
